import { render } from "./DeviceManagement.vue?vue&type=template&id=0507db1c&scoped=true"
import script from "./DeviceManagement.vue?vue&type=script&lang=js"
export * from "./DeviceManagement.vue?vue&type=script&lang=js"

import "./DeviceManagement.vue?vue&type=style&index=0&id=0507db1c&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0507db1c"]])

export default __exports__